import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";

import AdminRegistrationContext from "../../context/adminRegistration/adminRegistrationContext";
import AuthContext from "../../context/auth/authContext";

import RegistrationContext from "../../context/registration/registrationContext";

import timeValues from "../../data/timeValues";

import moment from "moment";

const VirtualOrientationCard = ({ link, setLink, onSubmit }) => {
  return (
    <div className="virtual-orientation-form">
      <div className="group form">
        <div className="item">
          <h3>Orientation Link</h3>
          <input
            type="text"
            value={link}
            onChange={(e) => setLink(e.target.value)}
            placeholder="Please Enter Orientation URL"
          />
        </div>
        <div className="btn btn-llac-dark-green" onClick={() => onSubmit()}>
          Submit
        </div>
      </div>
    </div>
  );
};
const LiveOrientationCard = ({ time, setTime, onSubmit }) => {
  const adminRegistrationContext = useContext(AdminRegistrationContext);
  const { orientation_info } = adminRegistrationContext;
  const [newTime, setNewTime] = useState({
    date: "",
    start_time: "",
    end_time: "",
  });
  const [showCustomDateButton, setShowCustomDateButton] = useState(
    orientation_info.orientation_dates &&
      orientation_info.orientation_dates.length < 1
  );

  const { date, start_time, end_time } = newTime;
  const customTimeCompleted =
    date !== "" && start_time !== "" && end_time !== "";

  const handleSubmit = () => {
    setTime(
      `${moment(date).utc().format("MM/DD/yyyy")} - ${start_time} - ${end_time}`
    );
    setShowCustomDateButton(false);
  };

  const handleOnChange = (e) => {
    setNewTime({ ...newTime, [e.target.name]: e.target.value });
  };
  return (
    <div className="live-orientation-form">
      <div className="group form">
        <div className="item">
          <h3>Select Orientation Date</h3>

          {orientation_info.orientation_dates &&
          orientation_info.orientation_dates.length > 0 ? (
            <select value={time} onChange={(e) => setTime(e.target.value)}>
              <option value="">Please Select An Orientation Date</option>
              {orientation_info.orientation_dates.map((item) => {
                const { date, start_time, end_time } = item;
                return (
                  <option
                    value={`${date} - ${start_time} - ${end_time}`}
                  >{`${date} - ${start_time} - ${end_time}`}</option>
                );
              })}
            </select>
          ) : (
            <div className="date-select">
              <input
                type="date"
                name="date"
                value={date}
                onChange={(e) => handleOnChange(e)}
              />
              <div className="time">
                <div className="left">
                  <p>From</p>
                  <select
                    name="start_time"
                    value={start_time}
                    onChange={(e) => handleOnChange(e)}
                  >
                    <option value="">Start Time</option>
                    {timeValues.map((item) => {
                      return <option value={item}>{item}</option>;
                    })}
                  </select>
                </div>
                <div className="right">
                  <p>To</p>
                  <select
                    name="end_time"
                    value={end_time}
                    onChange={(e) => handleOnChange(e)}
                  >
                    <option value="">End Time</option>
                    {timeValues.map((item) => {
                      return <option value={item}>{item}</option>;
                    })}
                  </select>
                </div>
              </div>
            </div>
          )}
        </div>
        {showCustomDateButton ? (
          <div className="btn btn-llac-dark-grey" onClick={handleSubmit}>
            Add Date
          </div>
        ) : (
          <div className="btn btn-llac-dark-green" onClick={onSubmit}>
            Submit
          </div>
        )}
      </div>
    </div>
  );
};

const ScheduleOrientation = ({ type }) => {
  const navigate = useNavigate();
  const registrationContext = useContext(RegistrationContext);
  const { submitData } = registrationContext;
  const adminRegistrationContext = useContext(AdminRegistrationContext);
  const {
    registration,
    sendOrientationEmail,
    orientation_info,
    formData,
    updateFormStatus,
    clearFormData,
    setFormModal,
    updateProcessingLevel,
  } = adminRegistrationContext;
  const authContext = useContext(AuthContext);
  const [orientationType, setOrientationType] = useState("VIRTUAL");
  const [orientationTime, setOrientationTime] = useState("");
  const [virtualLink, setVirtualLink] = useState(
    orientation_info.virtual_link ? orientation_info.virtual_link : ""
  );
  const { user } = authContext;

  const handlePreSubmit = async () => {
    const {
      firstName,
      lastName,
      learningCenterName,
      learningCenterCharter,
      learningCenterCoordinates,
      studentEmail,
    } = formData;
    let emailFormData = {
      id: "",
      type,
      name: `${firstName} ${lastName}`,
      location: learningCenterName,
      charter: learningCenterCharter,
      coordinates: learningCenterCoordinates,
      staffEmail: user.azureID,
      studentEmail,
    };

    if (orientationType === "VIRTUAL") {
      await submitData({
        ...formData,
        progressLevel: 1,
        orientationType: orientationType,
        orientationLink: virtualLink,
        orientationScheduled: true,
      });
      emailFormData.orientationLink = virtualLink;
      sendOrientationEmail(emailFormData, orientationType, type);
    } else {
      await submitData({
        ...formData,
        progressLevel: 1,
        orientationType: orientationType,
        orientationTime: orientationTime,
        orientationScheduled: true,
      });
      emailFormData.orientationTime = orientationTime;
      sendOrientationEmail(emailFormData, orientationType, type);
    }
    setFormModal("postRegistrationModal", false);
    navigate("/registration-forms");
    clearFormData();
  };

  const handlePostSubmit = () => {
    const {
      _id,
      firstName,
      lastName,
      learningCenterName,
      learningCenterCharter,
      learningCenterCoordinates,
      studentEmail,
    } = registration;

    let emailFormData = {
      type,
      id: _id,
      name: `${firstName} ${lastName}`,
      location: learningCenterName,
      charter: learningCenterCharter,
      coordinates: learningCenterCoordinates,
      staffEmail: user.azureID,
      studentEmail,
    };

    if (orientationType === "VIRTUAL") {
      emailFormData.orientationLink = virtualLink;
      sendOrientationEmail(emailFormData, orientationType, type);
    } else {
      emailFormData.orientationTime = orientationTime;
      sendOrientationEmail(emailFormData, orientationType, type);
    }
    updateProcessingLevel(2);
  };

  const onSubmit = () => {
    if (type === "PRE") {
      handlePreSubmit();
    } else {
      handlePostSubmit();
    }
  };

  return (
    <div className="schedule-orientation-container">
      <div className="flex-check-container">
        <label className="check-container">
          Virtual Orientation
          <input
            type="radio"
            value="no"
            checked={orientationType === "VIRTUAL"}
            onChange={() => setOrientationType("VIRTUAL")}
            name="registerForIntercession"
          />
          <span className="styled-checkmark"></span>
        </label>
        <label className="check-container">
          Live Orientation
          <input
            type="radio"
            value="yes"
            checked={orientationType === "LIVE"}
            onChange={() => setOrientationType("LIVE")}
            name="registerForIntercession"
          />
          <span className="styled-checkmark"></span>
        </label>
      </div>
      {orientationType === "VIRTUAL" && (
        <VirtualOrientationCard
          link={virtualLink}
          setLink={setVirtualLink}
          onSubmit={onSubmit}
        />
      )}
      {orientationType === "LIVE" && (
        <LiveOrientationCard
          time={orientationTime}
          setTime={setOrientationTime}
          onSubmit={onSubmit}
        />
      )}
    </div>
  );
};

export default ScheduleOrientation;
